import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule }                  from '@angular/common';
import { FormsModule }                   from '@angular/forms';
import { CsCheckboxComponent }           from './checkbox.component';

@NgModule({
    declarations: [CsCheckboxComponent],
    exports: [CsCheckboxComponent],
    imports: [CommonModule, FormsModule]
})
export class CsCheckboxModule {
	static forRoot(): ModuleWithProviders<CsCheckboxModule> {
		return {ngModule: CsCheckboxModule};
	}
}
